export default __webpack_public_path__ + "static/media/navbar-icon-allocations.5cd0668f.svg";